<template>
  <div class="rp-manager">
      <el-tabs v-model="activeName">
            <!-- <el-tab-pane label="审核文档" name="check"></el-tab-pane>
            <el-tab-pane label="归档文档" name="cate"></el-tab-pane> -->

            <div class="panelInstance">
                <div class="panelInstance-left">
                    <roleTree
                        @node-click="nodeClick"
                        :lazy="true"
                        :load="loadTree"
                        :defaultProps="treeProps"
                    />
                </div>
                <div class="panelInstance-right" v-loading="permLoading">
                    <permDoc 
                    :node="node" 
                    :type="tabType"
                    :submit="submitPerm"
                    ></permDoc>
                </div>
            </div>
        </el-tabs>
  </div>
</template>

<script>
import roleTree from '@/views/components/roleTree/index.vue'
import permDoc from '@/views/components/permDocument/index.vue'
import service from '@/xgzdService/setting-service'
import { mapState } from 'vuex'
import { promiseWrapper } from '@/utils/wrapper'
import permission from "@/xgzdService/docPrivi-service"
const ARCHIVE_DOCUMENT_ID = '2'
const AUDIT_DOCUMENT_ID = '1'
export default {
    components: {
        roleTree,
        permDoc
    },
    data: () => {
        return {
            activeName: 'check',
            treeProps: {
                $topLevel: '$topLevel',
                $id: 'roleID',
                children: 'childList',
                label: 'roleName'
            },
            node: null,
            permLoading: false
        }
    },
    computed: {
        ...mapState({
            prjInfo: (state) => state.projectMg.prjObj,
        }),
        tabType() {
            if (this.activeName === 'check') return AUDIT_DOCUMENT_ID
            return ARCHIVE_DOCUMENT_ID
        }
    },
    methods: {
        nodeClick(data) {
            this.node = data
        },
        async loadTree() {
            const { prjId } = this.prjInfo
            return promiseWrapper(service.getPrjRoleTreeByPrjNew(prjId), '[角色权限管理] 获取当前项目的目录树').then(res => {
                if (Array.isArray(res?.data)) return res.data
                console.warn('[角色权限管理] 当前项目的角色树信息异常')
                return []
            })
        },
        async submitPerm(params) {
            this.permLoading = true
            let res = await promiseWrapper(permission.savePrjRolePermission(params), '[角色权限管理] 提交变更的角色权限');
            if (res.result == '0') this.$message.success('权限变更成功')
            this.permLoading = false
        }
    }

}
</script>

<style lang="scss" scoped>
.rp-manager  {
    box-sizing: border-box;
    padding: 10px;
    height: 100%;

    /deep/ .el-tabs {
        display: flex;
        height: 100%;
        flex-flow: column nowrap;
        .el-tabs__header {
            margin: 0 0 0;
            * {
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                color: #999999;
            }
        }
        .el-tabs__item.is-active {
            color: #5584FF!important;
        }
        .el-tabs__active-bar {
            background-color: #5584FF!important;
            height: 1px!important;
        }
        .el-tabs__nav-wrap:after {
            height: 1px;
        }
        .el-tabs__content {
            min-height: 0;
            flex-grow: 1;
            overflow: hidden auto;
        }
    }
    .panelInstance {
        $left_width: 250px;
        height: 100%;
        display: flex;
         &-left {
            width: $left_width;
            box-sizing: border-box;
            padding: 10px 5px;
            border-right: 1px solid #f4f5fa;
        }
        &-right {
            width: calc(100% - #{$left_width});
        }
    }
}
</style>